/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityGroupNotificationSetting } from '../../models/facility-group-notification-setting';

export interface GetList_1$Params {
}

export function getList_1(http: HttpClient, rootUrl: string, params?: GetList_1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FacilityGroupNotificationSetting>>> {
  const rb = new RequestBuilder(rootUrl, getList_1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FacilityGroupNotificationSetting>>;
    })
  );
}

getList_1.PATH = '/api/facilityGroup/notification/setting';
